import React from 'react'

export default (props)=>{
  return(
    <svg className="MenuIcon Icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <line x1="11.6" y1="17.6" x2="11.6" y2="17.6"/>
      <line x1="11.6" y1="11.8" x2="11.6" y2="11.8"/>
      <line x1="11.6" y1="6.2" x2="11.6" y2="6.2"/>
    </svg>
  )
}
